import * as React from 'react'
import { SVGProps } from 'react'

function CustomCheckbox(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <rect width={23} height={23} x={0.5} y={0.5} fill="#fff" rx={5.5} />
      <rect width={23} height={23} x={0.5} y={0.5} stroke="#D4D4D4" rx={5.5} />
    </svg>
  )
}

function CheckedCustomCheckbox(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <rect width={24} height={24} fill={props.color ?? '#1D59AF'} rx={6} />
      <path stroke="#fff" strokeWidth={2} d="m5 12.5 4 4L18.5 7" />
    </svg>
  )
}
export default CheckedCustomCheckbox

export const Checkbox = {
  CheckedCustomCheckbox,
  CustomCheckbox,
}
